<template>
    <b-modal
        :id="modalId"
        modal-class="custom-modal"
        centered
        hide-header
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
    >
        <div class="area-modal">
            <div class="content-modal">
                <div
                    class="header"
                    v-html="lbl.home.otherConditionModal.title"
                ></div>
                <div class="content-modal-body">
                    <div class="content-modal-scroll">
                        <div
                            class="data-scroll"
                            v-html="lbl.home.otherConditionModal.body"
                        ></div>
                    </div>
                </div>
                <div class="bottom-modal">
                    <div
                        v-html="lbl.home.otherConditionModal.btnClose"
                        class="btn-close-border"
                        @click="hide()"
                    ></div>
                </div>
            </div>
        </div>
    </b-modal>
</template>
<script>
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";
/**
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "ScrollBodyModal",
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String
    },
    data: function() {
        return {
            title: "",
            message: "",
            btnOk: "",
            tag: "",
            busModal: null,
            lbl: Locale.getLbl()
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
    },
    methods: {
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function() {
            this.hide();
            this.controller.sendCallbackOk({ tag: this.tag });
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.tag = config.tag;
            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        }
    }
};
</script>
<style lang="scss" scoped>
@import "./modal.scss";
.data-scroll {
    color: #000;
    font-size: 1.5rem;
    line-height: 1;
}
.area-modal {
    .content-modal {
        .header {
            color: #000;
        }
        .content-modal-body {
            padding: 0 15px;
            .content-modal-scroll {
                height: 60vh;
                overflow: scroll;
                &::-webkit-scrollbar {
                    width: 4px;
                    background: #fff;
                    -web-kit-border-radius: 100px;
                }

                &::-webkit-scrollbar-thumb {
                    background: #cdcdcd;
                    border-radius: 10x;
                    box-shadow: 0px 1px 2px #cdcdcd;
                }
            }
        }
        .bottom-modal {
            .btn-close-black {
                color: #000;
                border: 1px solid #000;
            }
        }
    }
}
</style>
